export default __webpack_public_path__ + "static/media/CapaPerson.5595e97c.svg";